<template>
  <hypto-popup :title="'Filter Virtual Account Statements'">
    <template v-slot:body>
      <div class="merge-fields">
        <date-time-picker @updateDateTime="(newVal) => timeRange = newVal"
                          :timeRange="timeRange" :reset="resetRange" />

        <md-field id="PaymentType">
          <label>Payment Types</label>
          <md-select v-model="paymentTypes" @md-opened="setDropdownPosOffset('PaymentType')" multiple>
            <md-option v-for="(payment, index) in paymentOptions" :key="index" :value="payment">
              {{payment}}
            </md-option>
          </md-select>
        </md-field>

        <md-field v-if="showExtras" id="TransactionType">
          <label>Transaction Types</label>
          <md-select v-model="txnTypes" @md-opened="setDropdownPosOffset('TransactionType')" multiple>
            <md-option v-for="(txn, index) in txnOptions" :key="index" :value="txn">
              {{txn}}
            </md-option>
          </md-select>
        </md-field>

        <md-field v-if="showExtras" id="Statuses">
          <label>Statuses</label>
          <md-select v-model="statuses" @md-opened="setDropdownPosOffset('Statuses')" multiple>
            <md-option v-for="(status, index) in statusOptions" :key="index" :value="status">
              {{status}}
            </md-option>
          </md-select>
        </md-field>

        <div class="radio-btns">
          <h5>Sort Order</h5>
          <md-radio v-model="sortOrder" :value="'DESC'">Latest</md-radio>
          <md-radio v-model="sortOrder" value="ASC">Oldest</md-radio>
        </div>
      </div>
    </template>

    <template v-slot:footer>
      <button class="dark-btn" @click="reset">Reset</button>
      <button class="primary-btn" @click="filterAction">Filter</button>
    </template>
  </hypto-popup>
</template>

<script>
import DateTimePicker from '@/components/global/DateTimePicker'
import HyptoPopup from '@/components/global/HyptoPopup'

import moment from 'moment'
import { setDropdownPosOffset } from '@/utils/helpers'
import { mapGetters } from 'vuex'

export default {
  name: 'VAStatementFilter',
  components: { DateTimePicker, HyptoPopup },
  props: {
    showExtras: {
      type: Boolean
    }
  },
  data () {
    return {
      timeRange: [null, null],
      paymentOptions: [
        'HYPTO_TRANSFER',
        'UPI',
        'IMPS',
        'NEFT',
        'RTGS',
        'FT'
      ],
      paymentTypes: [],
      sortOrder: 'DESC',
      txnOptions: [
        'Received - VA',
        'Bank Transfer - VA',
        'Refund - Bank Transfer - VA',
        'Received - VA - UPI Payment',
        'Lien Marked - VA',
        'Lien Refund - VA'
      ],
      txnTypes: [],
      statusOptions: [
        'PENDING',
        'FAILED',
        'COMPLETED'
      ],
      statuses: [],
      resetRange: false
    }
  },
  computed: {
    ...mapGetters(['getterStatementFilter'])
  },
  created () {
    this.populateData()
  },
  methods: {
    setDropdownPosOffset,
    populateData () {
      const filter = this.getterStatementFilter
      this.paymentTypes = filter.payment_types || []
      this.sortOrder = filter.sort_order || 'DESC'

      if (this.showExtras) {
        this.txnTypes = filter.txn_types || []
        this.statuses = filter.statuses || []
      }

      if (filter.start_time) {
        this.timeRange = []
        this.timeRange.push(new Date(filter.start_time))
        this.timeRange.push(new Date(filter.end_time))
      }
    },
    filterAction () {
      let params = {
        sort_order: this.sortOrder
      }

      if (this.paymentTypes.length) {
        params['payment_types'] = this.paymentTypes
      }
      if (!this.timeRange.includes(null)) {
        const dateFormat = 'YYYY-MM-DD HH:mm:ss'
        params['start_time'] = moment(this.timeRange[0]).format(dateFormat)
        params['end_time'] = moment(this.timeRange[1]).format(dateFormat)
      }

      if (this.showExtras) {
        params['txn_types'] = this.txnTypes
        params['statuses'] = this.statuses
      }
      this.$emit('updateFilters', params)
    },
    reset () {
      this.resetRange = !this.resetRange
      this.paymentTypes = []
      this.txnTypes = []
      this.statuses = []
      this.sortOrder = 'DESC'
    }
  }
}
</script>
